import { $, useSignal, useId } from "@builder.io/qwik";
import { useBoundSignal } from "../../utils/bound-signal2.qwik.mjs";
function useRootItemsRepo() {
  const items = useSignal(/* @__PURE__ */ new Map());
  const rootId = useId();
  const itemsCSR = useSignal([]);
  const registerItem$ = $((itemId, itemSig) => {
    items.value = items.value.set(itemId, itemSig);
  });
  const getAndSetTabIndexItem$ = $((itemId, tabIndexValue) => {
    const itemSig = items.value.get(itemId);
    if (!itemSig)
      throw "Item Not Found";
    if (itemSig) {
      itemSig.value.tabIndex.value = tabIndexValue;
    }
  });
  const getAllItems$ = $(() => Array.from(items.value.values()).map((signal) => signal.value));
  return {
    getAllItems$,
    getAndSetTabIndexItem$,
    registerItem$,
    rootId,
    itemsCSR
  };
}
function useCreateSingleToggleGroup(props) {
  const { multiple = false, value, onChange$, "bind:value": givenValueSig } = props;
  const pressedValuesSig = useBoundSignal(givenValueSig, value);
  const rootItemsRepo = useRootItemsRepo();
  const handleValueChange$ = $((newValue) => {
    pressedValuesSig.value = newValue;
    if (onChange$)
      onChange$(pressedValuesSig.value);
  });
  const activateItem$ = $((itemValue) => handleValueChange$(itemValue));
  const deActivateItem$ = $(() => handleValueChange$(""));
  return {
    multiple,
    pressedValuesSig,
    activateItem$,
    deActivateItem$,
    getAllItems$: rootItemsRepo.getAllItems$,
    getAndSetTabIndexItem$: rootItemsRepo.getAndSetTabIndexItem$,
    registerItem$: rootItemsRepo.registerItem$,
    rootId: rootItemsRepo.rootId,
    itemsCSR: rootItemsRepo.itemsCSR
  };
}
function useCreateMultipleToggleGroup(props) {
  const { multiple = true, "bind:value": givenValueSig, value, onChange$ } = props;
  const pressedValuesSig = useBoundSignal(givenValueSig, value || []);
  const rootItemsRepo = useRootItemsRepo();
  const handleValueChange$ = $((newValue) => {
    pressedValuesSig.value = newValue;
    if (onChange$)
      onChange$(pressedValuesSig.value);
  });
  const activateItem$ = $((itemValue) => handleValueChange$([
    ...pressedValuesSig.value,
    itemValue
  ]));
  const deActivateItem$ = $((itemValue) => handleValueChange$(pressedValuesSig.value.filter((value2) => value2 !== itemValue)));
  return {
    multiple,
    pressedValuesSig,
    activateItem$,
    deActivateItem$,
    getAllItems$: rootItemsRepo.getAllItems$,
    getAndSetTabIndexItem$: rootItemsRepo.getAndSetTabIndexItem$,
    registerItem$: rootItemsRepo.registerItem$,
    rootId: rootItemsRepo.rootId,
    itemsCSR: rootItemsRepo.itemsCSR
  };
}
function isSingleProps(props) {
  return props.multiple === void 0 || props.multiple === false;
}
function useToggleGroup(props) {
  if (isSingleProps(props)) {
    return useCreateSingleToggleGroup(props);
  }
  return useCreateMultipleToggleGroup(props);
}
export {
  useToggleGroup
};
